import { Breadcrumb, Col, Layout, Row } from "antd";
import { useState } from "react";
import { SingleHeader } from "@components/header";
import { Helmet as Head } from "react-helmet-async";
import { useGetPagesQuery } from "@services/Page";
import { getWordpressVars } from "@lib/wordpressVars";
import { useGetPostsQuery } from '@mwServices/Post';
import { PostGrid } from '@components/grid';
import { LeftOutlined } from "@ant-design/icons";

const CollectorContentViewAllPage = () => {
  const ID = getWordpressVars().ID;
  const title = getWordpressVars().title;
  const image = getWordpressVars().image;
  const breadcrumbs = getWordpressVars().breadcrumbs;

  const [pagination, setPagination] = useState({
    type: 'Numbers',
    page: 1,
    perPage: 20,
  })

  const { data, isSuccess } = useGetPagesQuery({ id: ID });
  const { collections } = data?.results || {};

  const postsData = useGetPostsQuery({
    terms: collections?.terms,
    taxonomies: collections?.taxonomies,
    perPage: pagination.perPage,
    page: pagination.page,
  }, { skip: !isSuccess })


  const handleOnChange = (current: number, perPage: number) => {
    setPagination({
      ...pagination,
      page: current,
      perPage: perPage,
    });
  }

  return (
    <Layout className="page collectors-resources-view-all">
      <Head>
        <title>Collector Resources - {title}</title>
      </Head>
      <Row>
        <Col span={24}>
          <SingleHeader
            className={`hero-header`}
            title={title}
            imgSrc={image?.src}
            justify="center"
          />
        </Col>
      </Row>
      <Row
        className={`mar-top-20 mar-bot-30`}
        justify={`center`}
      >
        <Col xs={20} lg={20} className={`my-5`}>
          <Breadcrumb className={`breadcrumb`}>
            <Breadcrumb.Item href={breadcrumbs[0].url}>

            </Breadcrumb.Item>
            {breadcrumbs.map((crumb, index) =>
              <Breadcrumb.Item href={crumb.url}>
                {index === 0 && <LeftOutlined />}
                <span>{crumb.title}</span>
              </Breadcrumb.Item>
            )}
          </Breadcrumb>
        </Col>
      </Row>
      <Row justify={`center`} className="minHeight">
        <Col xs={20} lg={20}>
          {(postsData.data?.results && collections)
            && <PostGrid
              data={postsData.data?.results}
              perRow={collections.perRow}
              cta={{
                flip: collections.flipImg,
                type: collections.ctaType,
              }}
              onPaginationChange={handleOnChange}
              pagination={{
                ...postsData.data?.pagination,
                type: 'Numbers',
                simple: true
              }}
            />}
        </Col>
      </Row>
    </Layout>
  );
};

export default CollectorContentViewAllPage;


